import React from 'react';
import './Loader.css';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
  text?: string;
}

const Loader: React.FC<LoaderProps> = ({ 
  size = 'medium', 
  fullScreen = false,
  text 
}) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-16 h-16',
    large: 'w-24 h-24'
  };

  const loaderContent = (
    <div className={`flex flex-col items-center justify-center ${fullScreen ? 'min-h-screen' : 'py-12'}`}>
      <div className="relative">
        {/* Outer spinning ring */}
        <div className={`${sizeClasses[size]} border-4 border-[#0e4842] border-t-transparent rounded-full animate-spin`}></div>
        
        {/* Inner pulsing circle */}
        <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${sizeClasses[size === 'small' ? 'small' : size === 'medium' ? 'small' : 'medium']} bg-[#32ff7e] rounded-full animate-pulse opacity-75`}></div>
        
        {/* Center dot */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-[#0e4842] rounded-full"></div>
      </div>
      
      {text && (
        <p className="mt-4 text-[#0e4842] font-medium text-lg animate-pulse">
          {text}
        </p>
      )}
      
      {/* Animated dots */}
      {text && (
        <div className="flex space-x-1 mt-2">
          <span className="w-2 h-2 bg-[#32ff7e] rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
          <span className="w-2 h-2 bg-[#32ff7e] rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
          <span className="w-2 h-2 bg-[#32ff7e] rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
        </div>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-90 z-50 flex items-center justify-center">
        {loaderContent}
      </div>
    );
  }

  return loaderContent;
};

export default Loader;


